import CollapsableFlashcardListItem from "./collapsable-flashcard-list-item"
import type { UseQueryResult } from "@tanstack/react-query"
import type { GetAllResponse, SetDeck } from "@/services/api/flashcards/get-all"

interface CollapsableFlashcardListProps {
  flashcardsQuery: UseQueryResult<GetAllResponse, Error>
}

const getFlashcardsInfo = (data: GetAllResponse | undefined): SetDeck[] => {
  if (!data) return []
  const { other, sets } = data
  return sets.concat(other ?? [])
}

const CollapsableFlashcardList = ({ flashcardsQuery }: CollapsableFlashcardListProps) => {
  const { isLoading, isError, data, error, isFetching } = flashcardsQuery

  const flashcards = getFlashcardsInfo(data)

  if (isLoading || isFetching) {
    return <div className="size-sm text-center text-sm">Cargando...</div>
  }

  if (isError) {
    return <div className="size-sm text-center text-sm">{error.message}</div>
  }

  return flashcards.length > 0 ? (
    <div className="flex w-full max-w-full flex-col gap-4 overflow-hidden">
      {flashcards.map((flashcard) => (
        <CollapsableFlashcardListItem flashcard={flashcard} key={flashcard.id} />
      ))}
      {/* TO DO: Pagination component here */}
    </div>
  ) : (
    <div>
      <p className="select-none p-4 py-8 text-center text-gray-600">¡No tenés flashcards aún!</p>
    </div>
  )
}

export default CollapsableFlashcardList
